<template>
  <FooterBlock class="footer__location" :title="$t('footer.hourTable')">
    <div class="mt-0">
      <v-row v-for="hourRow of hourTable">
        <template v-if="hourRow.label">
          <v-col>
            <span v-text="$t(`days.${hourRow.label}`)" />
          </v-col>
          <v-col class="text-right">
            <span v-text="`${hourRow.q1[0]} - ${hourRow.q2[1]}`" />
          </v-col>
        </template>
      </v-row>
    </div>
  </FooterBlock>
</template>

<script setup lang="ts">
const {hourTable} = useConfig()
</script>

<style scoped lang="scss">
.footer__location {
  line-height: 28px;

  .v-row {
    line-height: 9px;
    border-bottom: 1px dotted black;
    margin: 12px 0;

    .v-col {
      padding: 6px 0 0 0;

      span {
        background: white;
      }

      &:first-child {
        span {
          padding-right: 8px;
        }
      }

      &:last-child {
        span {
          padding-left: 8px;
        }
      }
    }
  }
}
</style>